module.exports = __webpack_public_path__ + "img/shield.2c525214.png";